export enum SimulationStatus {
  New = "new",
  Test = "test",
  Investigation = "investigation",
  Anonymized = "anonymized",
  Demo = "demo",
}
